
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 22 22"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_24698","data-name":"Group 24698","transform":"translate(.387 .5)"}},[_c('g',{attrs:{"id":"Rectangle_7977","data-name":"Rectangle 7977"}},[_c('rect',{attrs:{"id":"Rectangle_7978","data-name":"Rectangle 7978","width":"21","height":"21","rx":"5","transform":"translate(.113)","fill":"#fff","stroke":"#dfe4ef","stroke-width":"1"}})]),_c('g',{attrs:{"id":"Group_22818","data-name":"Group 22818","transform":"translate(4 9)"}},[_c('g',{attrs:{"id":"Group_22817","data-name":"Group 22817","fill":"#5a677d"}},[_c('circle',{attrs:{"id":"Ellipse_290","data-name":"Ellipse 290","cx":"1.5","cy":"1.5","r":"1.5"}}),_c('circle',{attrs:{"id":"Ellipse_291","data-name":"Ellipse 291","cx":"1.5","cy":"1.5","r":"1.5","transform":"translate(5)"}}),_c('circle',{attrs:{"id":"Ellipse_292","data-name":"Ellipse 292","cx":"1.5","cy":"1.5","r":"1.5","transform":"translate(10)"}})])])])])
          )
        }
      }
    